module.exports = __webpack_public_path__ + "img/school.fc570ca7.png";